import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Toolbar from "./components/toolbar/ToolbarEnhanced";
import SideDrawer from "./components/sideDrawer/SideDrawer";
import Backdrop from "./components/backdrop/Backdrop";
import AdSenseLayout from "./components/layout/AdSenseLayout";
import Home from "./components/home/Home";
import Areas from "./components/areas/Area";
import Lengths from "./components/lengths/Length";
import Speeds from "./components/speeds/Speed";
import Temperatures from "./components/temperatures/Temperature";
import Times from "./components/times/Time";
import Volumes from "./components/volumes/Volume";
import Weights from "./components/weights/Weight";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import TermsOfService from "./components/legal/TermsOfService";
import Footer from "./components/footer/Footer";
import { initGA, trackPageView } from "./utils/analytics";
import "w3-css/3/w3.css";

function App() {
  const [sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const location = useLocation();

  // Initialize Google Analytics on app start
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  const drawerToggleClickHandler = () => {
    setSideDrawerOpen(prevState => !prevState);
  };

  const backdropClickHandler = () => {
    setSideDrawerOpen(false);
  };

  return (
    <>
      <Toolbar drawerClickHandler={drawerToggleClickHandler} />
      <SideDrawer show={sideDrawerOpen} />
      {sideDrawerOpen && <Backdrop click={backdropClickHandler} />}

      <AdSenseLayout showSidebar={true}>
        <div className="conversion-tool-container" style={{ marginTop: "90px" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/conversion/area" element={<Areas />} />
            <Route path="/conversion/length" element={<Lengths />} />
            <Route path="/conversion/speed" element={<Speeds />} />
            <Route path="/conversion/temperature" element={<Temperatures />} />
            <Route path="/conversion/time" element={<Times />} />
            <Route path="/conversion/volume" element={<Volumes />} />
            <Route path="/conversion/weight" element={<Weights />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </div>
      </AdSenseLayout>

      <Footer />
    </>
  );
}

export default App;
